import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const deleteIslandMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Delete Island',
		isVisible: ({ controller, refMap }): boolean => {
			const { island } = refMap ?? {};
			if (controller.readonly || !island) return false;

			return island.islandConnectionCount <= 1;
		},
		onClick: ({ controller, refMap }): void => {
			// const refMap = controller?.kitchen?.getReferenceMap(context.id);
			const island = refMap?.island ?? null;
			const islands = controller?.kitchen?.design.islands ?? null;

			if (islands && island) islands.delete(island.id);
		}
	}
};
